import { buildContactIdLookupHooks } from 'bundles/crm/imports/helpers';

export const groupId = 'crm_properties';

const ownerHooks = buildContactIdLookupHooks(
  'Owner Contact Id',
  { idKey: 'ownerContactId', queryKey: 'ownerContact' },
);

export function getDromoImporterConfig() {
  return {
    bulkRowHooks: [ownerHooks.bulkRowHook],
    dromoSchemaId: '09102add-4192-48f1-8f13-b977fff73e8f',
    groupId,
    importerOptions: {
      parser: 'Backoffice::Importer::Providers::Dromo::Parsers::Properties',
    },
    importerType: 'crm',
    stepHooks: [ownerHooks.stepHook],
  };
}
